import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { nullSafe } from 'Utility/globalMethods'
import * as ResultsActions from '../../modules/ResultsActions'
import ClientDetail from './ClientsDetail'
import { doHidePopup } from 'Store/actions/popup'

const mapDispatchToProps = (dispatch) => ({
  ...bindActionCreators(ResultsActions, dispatch),
  doClosePopup: (type) => dispatch(doHidePopup(type))
})

const mapStateToProps = (state) => ({
  tabSelected: nullSafe(() => state.Results.tabSelected, 'ONE_PERIOD'),
  clientsDetails: nullSafe(() => state.Results.clientsDetails, {}),
  referredPeriod: nullSafe(() => state.Results.referredPeriod, []),
  isClientsDetailsLoading: nullSafe(() => state.loading.localLoading.get_total_clients_details, false),
  lastAppliedParams: nullSafe(() => state.Results.lastAppliedParams, null)
})

export default connect(mapStateToProps, mapDispatchToProps, (stateProps, dispatchProps, mergeProps) => ({
  ...stateProps,
  ...mergeProps,
  actions: dispatchProps
}))(ClientDetail)
